import { render } from "./TicketTableComponent.vue?vue&type=template&id=56c0bce2"
import script from "./TicketTableComponent.vue?vue&type=script&lang=js"
export * from "./TicketTableComponent.vue?vue&type=script&lang=js"

import "./TicketTableComponent.vue?vue&type=style&index=0&id=56c0bce2&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__